import { useTranslation } from 'react-i18next';

import {
    Body1,
    ConditionalComponent,
    Heading1,
    Heading2,
    HorizontalDivider,
    IconLock,
    NavLink,
    Stack,
    Subtitle2,
    formatPhoneNumber,
} from '@myphx-engineering/phx-design-system';

import { useFlags } from '../../../hooks/use-flags';
import { usePatientContext } from '../../../hooks/use-patient-context';
import { formatToLocalizedDate } from '../../../util';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

export const ProfilePage = () => {
    const { t, i18n } = useTranslation();
    const { patient } = usePatientContext();
    const { enableLdConsentManagement } = useFlags();

    return (
        <Stack gap="sm">
            <Stack gap="sm">
                <Heading1>{t('profile.heading')}</Heading1>
                <Heading2 data-testid="primary-user-full-name">
                    {patient?.fullName}
                </Heading2>
            </Stack>
            <Stack gap="xs">
                {patient?.email && (
                    <Stack gap="xxxs">
                        <Subtitle2>{t('profile.email')}</Subtitle2>
                        <Body1>{patient.email}</Body1>
                    </Stack>
                )}
                {patient?.dateOfBirth && (
                    <Stack gap="xxxs">
                        <Subtitle2>{t('profile.dob')}</Subtitle2>
                        <Body1>
                            {formatToLocalizedDate(
                                new Date(patient.dateOfBirth),
                                {
                                    dateStyle: 'medium',
                                    timeZone: 'UTC',
                                },
                                i18n.language
                            )}
                        </Body1>
                    </Stack>
                )}
                {patient?.phoneNumber && (
                    <Stack gap="xxxs">
                        <Subtitle2>{t('profile.phone')}</Subtitle2>
                        <Body1>{formatPhoneNumber(patient.phoneNumber)}</Body1>
                    </Stack>
                )}
            </Stack>
            <HorizontalDivider variant="full" />
            <ConditionalComponent condition={enableLdConsentManagement}>
                <NavLink
                    Icon={IconLock}
                    label={t('profile.consents.dataPrivacy')}
                    variant="subtle"
                    href={getAbsoluteRoute('profile.consents.root')}
                />
            </ConditionalComponent>
        </Stack>
    );
};
